import http from 'hub-http/clients/apiClient';
import { BackendView } from '../../viewsSearch/types/ViewTypes';

export const defaultPinnedViewsApi = {
  get: ({
    objectTypeId,
    namespaceName,
  }: {
    objectTypeId: string;
    namespaceName: string;
  }) => {
    return http
      .get(
        //?fallbackToGlobalDefault=true will make this api return the hardcoded defaults if no custom changes have been made by the user
        `/sales/v4/views/${objectTypeId}/pinned/hub?fallbackToGlobalDefault=true&namespace=${namespaceName}`
      )
      .then((result) => result as Array<BackendView>);
  },

  put: ({
    objectTypeId,
    viewIds,
    namespaceName,
  }: {
    objectTypeId: string;
    viewIds: string[];
    namespaceName: string;
  }) => {
    return http
      .put(
        `/sales/v4/views/${objectTypeId}/pinned/hub?namespace=${namespaceName}`,
        {
          data: viewIds,
        }
      )
      .then((result) => result as Array<BackendView>);
  },
};
